import handleError from '../handleError'
import { loadJsonApiEntities } from '../loadJsonApiEntities'
import { fetchMoments } from './fetchMoments'

export const getMoments =
  ({ component, currentBrandId, params, scopeToCurrentBrand }) =>
  async (dispatch, getState) => {
    const getParams = params

    if (scopeToCurrentBrand) {
      const currentState = getState()
      getParams['filter[brand_id]'] =
        currentState.current_workspace_id || currentBrandId
    }
    return fetchMoments(getParams)
      .then((response) => dispatch(loadJsonApiEntities(response.data)))
      .catch((error) => {
        if (component) {
          dispatch(handleError({ component, error }))
        }
        throw error
      })
  }

export default getMoments
